export interface ServiceWorkerRegistrationOptions {
  readonly buildId: string;
  readonly production: boolean;
  readonly secureContext: boolean;
  readonly hostname: string;
}

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

export async function registerServiceWorker({
  buildId,
  production,
  secureContext,
  hostname,
}: ServiceWorkerRegistrationOptions): Promise<void> {
  if (
    !production ||
    !/^[A-Za-z0-9_-]{8,128}$/u.test(buildId) ||
    (!secureContext && !LOCAL_HOSTNAMES.has(hostname)) ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  try {
    await navigator.serviceWorker.register(
      `/sw.js?build=${encodeURIComponent(buildId)}`,
      { scope: "/" },
    );
  } catch {
    // Offline support is progressive enhancement and must not block the app.
  }
}
